import { intl } from '~lib/intl';
import { formatPrice } from '~utils/number';

export function useFormatPrice() {
  return (value) => {
    return formatPrice(value, intl.currencySymbol);
  };
}

export function useFormatPriceWithDiscount() {
  return (value, discount) => {
    const hundred = 100;
    const discountValue = (value * discount) / hundred;
    const finalValue = value - discountValue;
    return formatPrice(finalValue, intl.currencySymbol);
  };
}
